import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Button,
  Box,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const DowngradePlanDialog = ({
  open,
  onClose,
  planName,
  onConfirm,
  isLoading = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 1,
        }}
      >
        <Typography variant="h6" fontWeight="bold" sx={{ textTransform: "lowercase" }}>
          downgrade
        </Typography>
        <IconButton
          onClick={onClose}
          size="small"
          sx={{ color: "text.secondary" }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ py: 1 }}>
          <Typography variant="body1" sx={{ mb: 2, textTransform: "lowercase" }}>
            your package will switch from the next month
          </Typography>
          <Typography variant="body1" sx={{ textTransform: "lowercase" }}>
            you sure you wanted to downgrade to{" "}
            <Box component="span" fontWeight="bold">
              {planName}
            </Box>
            ?
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, pt: 1 }}>
        <Button
          onClick={onConfirm}
          variant="contained"
          disabled={isLoading}
          sx={{
            textTransform: "lowercase",
            bgcolor: "#9347FF",
            "&:hover": {
              bgcolor: "#8938e9",
            },
          }}
        >
          {isLoading ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <CircularProgress size={16} color="inherit" />
              processing...
            </Box>
          ) : (
            "downgrade"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DowngradePlanDialog;

